import { PutFinanceAccountsApi } from "@/features/accounts/finance/services/put-accounts-api";
import { PutFinanceAccountsRequestModel } from "@/features/accounts/finance/services/put-accounts-model";

/// 銀行口座更新処理
export class PutFinanceAccountsService {
  private putFinanceAccountsApi = new PutFinanceAccountsApi();

  /**
   * 銀行口座更新API実行
   */
  public async putFinanceAccounts(param: PutFinanceAccountsRequestModel) {
    return await this.putFinanceAccountsApi.putFinanceAccounts(param);
  }
}
